module.exports = __webpack_public_path__ + "img/inside_carriage.c5f653f7.png";